import {
    UserLoginActionState,
    UserState,
} from "@infrastructure/Persistence/UserState";
import * as client from "../ClientConsumer";
import { generatePath } from "react-router-dom";
import {
    RESPONSE_CODE_NOT_AUTHORIZED,
    RESPONSE_CODE_PRIVACY_POLICY_UNACCEPTED,
    RESPONSE_CODE_PROFILE_DEACTIVATED,
    RESPONSE_CODE_PROFILE_SUSPENDED,
    RESPONSE_CODE_PROFILE_UNAUTHENTICATED,
    RESPONSE_CODE_SUCCESS,
} from "@infrastructure/BackendClientCodes";
import { AxiosError } from "axios";
import { PostIdType } from "../../Presentation/Components/Post/Post.types";

const authRoutes = {
    UPDATE_USER_DATA_FROM_SSO: "/community/users/:userId/update",
    GET_USER_ID: "/userId",
    CHECK_USER_TOKEN: "/auth/validate",
};

const profileState: {
    [key: number]: UserState;
} = {
    [RESPONSE_CODE_SUCCESS]: UserState.PROFILE_STATUS_ACTIVATED,
    [RESPONSE_CODE_PROFILE_UNAUTHENTICATED]:
        UserState.PROFILE_STATUS_UNAUTHENTICATED,
    [RESPONSE_CODE_NOT_AUTHORIZED]: UserState.PROFILE_STATUS_UNAUTHENTICATED,
    [RESPONSE_CODE_PRIVACY_POLICY_UNACCEPTED]:
        UserState.PROFILE_STATUS_NOT_ONBOARDED,
    [RESPONSE_CODE_PROFILE_DEACTIVATED]: UserState.PROFILE_STATUS_DEACTIVATED,
    [RESPONSE_CODE_PROFILE_SUSPENDED]: UserState.PROFILE_STATUS_SUSPENDED,
};

export function checkAuthToken(userSource?: UserLoginActionState): Promise<{
    isOnboarded: boolean;
    state: UserState;
    uuid: string | null;
}> {
    let options = {};
    if (userSource) {
        options = { params: { userSource } };
    }
    return client
        .getData(authRoutes.CHECK_USER_TOKEN, options, false)
        .then((res) => {
            let state = UserState.PROFILE_STATUS_UNAUTHENTICATED;
            if (res.status === RESPONSE_CODE_SUCCESS) {
                if (res.data.isOnboarded) {
                    state = UserState.PROFILE_STATUS_ACTIVATED;
                } else if (res.data.uuid) {
                    state = UserState.PROFILE_STATUS_NOT_ONBOARDED;
                }
            } else if (
                res.status !== RESPONSE_CODE_SUCCESS &&
                profileState[res.status]
            ) {
                state = profileState[res.status];
            }

            return {
                uuid: res.data.uuid,
                state: state,
                isOnboarded: res.data.isOnboarded,
            };
        })
        .catch((error: AxiosError) => {
            return {
                uuid: null,
                state: profileState[error.response?.status],
                isOnboarded: false,
            };
        });
}

export function updateUserInBackendFromSso(userId: string | number) {
    return client.putData(
        generatePath(authRoutes.UPDATE_USER_DATA_FROM_SSO, {
            userId: userId,
        }),
    );
}

export async function getUserIdService(): Promise<UserIdResponse> {
    const res = await client.getData(authRoutes.GET_USER_ID);
    return res.data;
}

export interface UserIdResponse {
    interactions: UserInteractions;
    userId: string;
}

export type PollResponse = {
    optionId: number;
    postId: PostIdType;
    quizAnswerOptionId: number | undefined;
};

export type ReactionResponseType = {
    objectId: number;
    objectType: "comment" | "post";
    reactionName: string;
};

type PostCommentsResponse = {
    commentsCount: number;
    postId: number;
};

export type UserInteractions = {
    polls: PollResponse[];
    postsComments: PostCommentsResponse[];
    reactions: ReactionResponseType[];
};
